import { useCallback } from 'react';
import { useOpenCreateLifeAreaDialog } from 'shared/contexts/life-area-form';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';

import { useCreateCustomLifeAreasAllowed } from './use-create-custom-life-areas-allowed';

// The one premium gate for every create-life-area entry point: free users past the limit get the premium dialog.
export const useOpenCreateLifeArea = () => {
  const openCreateDialog = useOpenCreateLifeAreaDialog();
  const openPremiumDialog = useOpenPremiumDialog();
  const { allowed } = useCreateCustomLifeAreasAllowed();

  return useCallback(
    () => (allowed ? openCreateDialog() : openPremiumDialog()),
    [allowed, openCreateDialog, openPremiumDialog],
  );
};
